export const getPublicContext = () => {
  const publicAppPath = process.env.PUBLIC_URL.split('/').filter(s => s.length);
  return publicAppPath[publicAppPath.length - 1]
}